import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Select,
    MenuItem,
    Checkbox,
    FormControlLabel, Autocomplete
} from "@mui/material";
import Loading from "../../Components/Loading/Loading";
import styles from "./RevokeEditions.module.css";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../Components/Button/Button";
import { updatePost } from "../../Services/Slices/postSlice";
import {fetchListPosts} from "../../Services/Slices/listPostsSlice";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import katex from "katex";
import "katex/dist/katex.min.css";
import Snackbar from "../../Components/Snackbar/Snackbar";
import {MdOutlineFileOpen} from "react-icons/md";
import {formatFileName} from "../../Components/Helper";
import { PATH } from "../../PATH";


const editorOptions = {
    height: '200',
    buttonList: [
        ["undo", "redo"],
        ["removeFormat"],
        ["bold", "underline", "italic", "fontSize"],
        ["fontColor", "hiliteColor"],
        ["align", "horizontalRule", "list"],
        ["table", "link"],
        ["showBlocks", "codeView"],
        ["math"]
    ],
    katex: katex,
    imageRotation: false,
    inlineStyle: true,
    strictMode: false,
    fontSize: [12, 14, 16, 18, 20],
    colorList: [
        "#828282", "#FF5400", "#676464", "#F1F2F4", "#FF9B00", "#F00", "#fa6e30",
        "#000", "rgba(255, 153, 0, 0.1)", "#FF6600", "#0099FF", "#74CC6D", "#FF9900", "#CCCCCC"
    ]
};

const RevokeEditions = () => {
    const dispatch = useDispatch();
    const { fileName } = useParams();
    const url = `${PATH.baseApi}/render-html/?file_key=${fileName}`;

    const [htmlContent, setHtmlContent] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const [openDialog1, setOpenDialog1] = useState(false);
    const [openDialog2, setOpenDialog2] = useState(false);
    const [openDialog3, setOpenDialog3] = useState(false);
    const [selectedText, setSelectedText] = useState<string>("");
    const [newText, setNewText] = useState<string>("");
    const [selectedFiles, setSelectedFiles] = useState<string[]>([]);
    let [selectedHtml, setSelectedHtml] = useState<string>("");
    const [isNoText, setIsNoText] = useState<boolean>(false);
    const [isExecutionSuspended, setIsExecutionSuspended] = useState<boolean>(false);
    const [isVide, setIsVide] = useState<boolean>(false);
    const [textPositions, setTextPositions] = useState<number[]>([]);
    const [selectedPosition, setSelectedPosition] = useState<number | null>(null);
    const [highlightedHtml, setHighlightedHtml] = useState<string>("");
    const [isRedaction, setIsRedaction] = useState<boolean>(false);
    const [isRenumbered, setIsRenumbered] = useState<boolean>(false);
    const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
    const [snackbarSameSelection, setSnackbarSameSelection] = useState<boolean>(false);

    const listPosts = useSelector((state: any) => state.listPostsSlice);

    useEffect(() => {
        const fetchHtml = async () => {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error("Erro! Tente novamente mais tarde.");
                }
                const html = await response.text();
                setHtmlContent(html);
                selectedHtml = selectedHtml.replace("<tbody>", "").replace("</tbody>", "")
                selectedHtml = cleanTable(selectedHtml)

                const { highlightedHtml, textPositions } = getHighlightedOccurrencesWithNumbers(html, selectedHtml);
                setHighlightedHtml(highlightedHtml);
                setTextPositions(textPositions);

                setLoading(false);
            } catch (err) {
                const errorMessage = (err as Error).message;
                setError(errorMessage);
                setLoading(false);
            }
        };
        
        fetchHtml();
    }, [url, selectedText, selectedHtml]);

    useEffect(() => {
        dispatch<any>(fetchListPosts("1", true));
    }, [dispatch]);

    const handleMouseUp = () => {
        if (!openDialog1 && !openDialog2) {
            const selection = window.getSelection();
            try{
                if (selection && selection.rangeCount > 0) {
                    const selectedRange = selection.getRangeAt(0);
                    const selectedHtml = selectedRange.cloneContents();
    
                    const tempDiv = document.createElement('div');
                    tempDiv.appendChild(selectedHtml);
                    let selectedHtmlContent = tempDiv.innerHTML.trim();
                    const selectedTextContent = selectedHtmlContent.replace(/<\/?[^>]+(>|$)/g, "").trim();

                    if (selectedTextContent && selectedTextContent.length > 0) {
                        setSelectedText(selectedTextContent);
                        setSelectedHtml(selectedHtmlContent);
    
                        if (selectedHtmlContent.startsWith('<table') && selectedHtmlContent.endsWith("</table><p></p>")) {
                            selectedHtmlContent = selectedHtmlContent.replace("</table><p></p>", "</table>")
                        }
                        if (selectedHtmlContent.startsWith('<table') && selectedHtmlContent.endsWith("</table><p><br></p><p></p>")) {
                            selectedHtmlContent = selectedHtmlContent.replace("</table><p><br></p><p></p>", "</table>")
                        }
                        if (selectedHtmlContent.startsWith('<p><br></p><table') && selectedHtmlContent.endsWith("</table><p><br></p><p></p>")) {
                            selectedHtmlContent = selectedHtmlContent.replace("<p><br></p><table", "<table").replace("</table><p><br></p><p></p>", "</table>")
                        }
                        if (selectedHtmlContent.startsWith('<p><br></p><table') && selectedHtmlContent.endsWith("</table><p></p>")) {
                            selectedHtmlContent = selectedHtmlContent.replace("<p><br></p><table", "<table").replace("</table><p></p>", "</table>")
                        }
                        if (selectedHtmlContent.startsWith('<p><br></p><table') && selectedHtmlContent.endsWith("</table>")) {
                            selectedHtmlContent = selectedHtmlContent.replace("<p><br></p><table", "<table")
                        }
                        if (selectedHtmlContent.startsWith('<p style="text-align: justify;"><br></p><table') && selectedHtmlContent.endsWith('</table><p style=\"text-align: justify;\"></p>')) {
                            selectedHtmlContent = selectedHtmlContent.replace('<p style="text-align: justify;"><br></p><table', "<table").replace('</table><p style=\"text-align: justify;\"></p>', "</table>")
                        }
                        if (selectedHtmlContent.startsWith('<p style="text-align: justify;"><br></p><table') && selectedHtmlContent.endsWith('</table><p style="text-align: justify;"><br></p><p style="text-align: justify;"></p>')) {
                            selectedHtmlContent = selectedHtmlContent.replace('<p style="text-align: justify;"><br></p><table', "<table").replace('</table><p style="text-align: justify;"><br></p><p style="text-align: justify;"></p>', "</table>")
                        }
                        if (selectedHtmlContent.startsWith('<table') && selectedHtmlContent.endsWith('</table><p style="text-align: justify;"></p>')) {
                            selectedHtmlContent = selectedHtmlContent.replace('</table><p style="text-align: justify;"></p>', "</table>")
                        }
                        if (selectedHtmlContent.startsWith('<p style="text-align: justify;"><br></p><table') && selectedHtmlContent.endsWith("</table>")) {
                            selectedHtmlContent = selectedHtmlContent.replace('<p style="text-align: justify;"><br></p><table', "<table")
                        }
                        if (selectedHtmlContent.startsWith('<table') && selectedHtmlContent.endsWith('</table><p style=\"text-align: justify;\"></p>')) {
                            selectedHtmlContent = selectedHtmlContent.replace('</table><p style=\"text-align: justify;\"></p>', "</table>")
                        }
                        if (selectedHtmlContent.startsWith('<table') && selectedHtmlContent.endsWith('</table><p style="text-align: justify;"><br></p><p style="text-align: justify;"></p>')) {
                            selectedHtmlContent = selectedHtmlContent.replace('</table><p style="text-align: justify;"><br></p><p style="text-align: justify;"></p>', "</table>")
                        }
    
                        const occurrences = countOccurrences(htmlContent, selectedHtmlContent.replace("<tbody>", "").replace("</tbody>", ""));
                        console.log("OCCURRENCES: ", occurrences)
                        if (occurrences > 1) {
                            setOpenDialog1(true);
                        } else {
                            setOpenDialog2(true);
                        }
                    }
                }
            } catch (error) {
                setSelectedHtml("");
                setSelectedText("");
                setSnackbarOpen(true);
            }
        }
    };

    const cleanTable = (selectedHtml: any) => {
        if (selectedHtml.startsWith('<table') && selectedHtml.endsWith("</table><p></p>")) {
            selectedHtml = selectedHtml.replace("</table><p></p>", "</table>")
        }
        if (selectedHtml.startsWith('<table') && selectedHtml.endsWith("</table><p><br></p><p></p>")) {
            selectedHtml = selectedHtml.replace("</table><p><br></p><p></p>", "</table>")
        }
        if (selectedHtml.startsWith('<p><br></p><table') && selectedHtml.endsWith("</table><p><br></p><p></p>")) {
            selectedHtml = selectedHtml.replace("<p><br></p><table", "<table").replace("</table><p><br></p><p></p>", "</table>")
        }
        if (selectedHtml.startsWith('<p><br></p><table') && selectedHtml.endsWith("</table><p></p>")) {
            selectedHtml = selectedHtml.replace("<p><br></p><table", "<table").replace("</table><p></p>", "</table>")
        }
        if (selectedHtml.startsWith('<p><br></p><table') && selectedHtml.endsWith("</table>")) {
            selectedHtml = selectedHtml.replace("<p><br></p><table", "<table")
        }
        if (selectedHtml.startsWith('<p style="text-align: justify;"><br></p><table') && selectedHtml.endsWith('</table><p style=\"text-align: justify;\"></p>')) {
            selectedHtml = selectedHtml.replace('<p style="text-align: justify;"><br></p><table', "<table").replace('</table><p style=\"text-align: justify;\"></p>', "</table>")
        }
        if (selectedHtml.startsWith('<p style="text-align: justify;"><br></p><table') && selectedHtml.endsWith('</table><p style="text-align: justify;"><br></p><p style="text-align: justify;"></p>')) {
            selectedHtml = selectedHtml.replace('<p style="text-align: justify;"><br></p><table', "<table").replace('</table><p style="text-align: justify;"><br></p><p style="text-align: justify;"></p>', "</table>")
        }
        if (selectedHtml.startsWith('<table') && selectedHtml.endsWith('</table><p style="text-align: justify;"></p>')) {
            selectedHtml = selectedHtml.replace('</table><p style="text-align: justify;"></p>', "</table>")
        }
        if (selectedHtml.startsWith('<p style="text-align: justify;"><br></p><table') && selectedHtml.endsWith("</table>")) {
            selectedHtml = selectedHtml.replace('<p style="text-align: justify;"><br></p><table', "<table")
        }
        if (selectedHtml.startsWith('<table') && selectedHtml.endsWith('</table><p style=\"text-align: justify;\"></p>')) {
            selectedHtml = selectedHtml.replace('</table><p style=\"text-align: justify;\"></p>', "</table>")
        }
        if (selectedHtml.startsWith('<table') && selectedHtml.endsWith('</table><p style="text-align: justify;"><br></p><p style="text-align: justify;"></p>')) {
            selectedHtml = selectedHtml.replace('</table><p style="text-align: justify;"><br></p><p style="text-align: justify;"></p>', "</table>")
        }
        return selectedHtml
    }

    const countOccurrences = (html: string, text: string): number => {
        const regex = new RegExp(text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
        return (html.match(regex) || []).length;
    };

    const handleCloseDialog1 = () => {
        setOpenDialog1(false);
        setTextPositions([]);
        setSelectedPosition(null);
    };

    const handleCloseDialog2 = () => {
        setOpenDialog2(false);
    };

    const handleCloseDialog3 = () => {
        setOpenDialog3(false);
    };

    const handleSelectPosition = () => {
        if (selectedPosition !== null) {
            setOpenDialog1(false);
            setIsNoText(false);
            setIsExecutionSuspended(false);
            setOpenDialog2(true);
        }
    };

    const handleRedaction = () => {
        setIsRedaction(true);
        setIsRenumbered(false);
    };

    const handleRenumbered = () => {
        setIsRedaction(false);
        setIsRenumbered(true);
    };

    const handleSubmit = () => {
        const convertNewTextToTableStructure = (newText: any) => {
            let cleanText = newText.replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<br>/g, ' ');
            const textParts = cleanText.split('//');
            const tableStructure = textParts.map((textPart: any) => `<td>${textPart.trim()}</td>`).join('');
            return `<tr>${tableStructure}</tr>`;
        };

        let formattedNewText = newText;
        if (selectedHtml.startsWith('<td>')) {
            formattedNewText = convertNewTextToTableStructure(newText);
        }

        selectedHtml = cleanTable(selectedHtml)

        let finalText = formattedNewText
            .replace('<table class="se-table-layout-auto">', '<table border="1" cellpadding="5" cellspacing="0">')
            .replace('<table>', '<table border="1" cellpadding="5" cellspacing="0">');

        if (/^(?:\s|&nbsp;)+$/i.test(finalText)) {
            finalText = '';
        }

        const data = {
            file_name: fileName,
            old_text: selectedHtml,
            new_text: finalText,
            edition: selectedFiles[0],
            status: "Vigente Alterada",
            execution_suspended: isExecutionSuspended,
            vide: isVide,
            is_renumbered: isRenumbered,
            text_position: selectedPosition
        };
        dispatch<any>(updatePost(data));
        setIsExecutionSuspended(false);
        setIsNoText(false);
    };

const escapeRegExp = (string: string) =>
    string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const splitHtmlParts = (html: string) => {
    return html.match(/<\/?[^>]+>|[^<]+/g) || [];
};

const getHighlightedOccurrencesWithNumbers = (fullHtml: string, selectedHtml: string) => {
    const cleaned = selectedHtml.trim();
    if (!cleaned) return { highlightedHtml: fullHtml, textPositions: [] };

    const escapedBlock = escapeRegExp(cleaned);
    const blockRegex = new RegExp(escapedBlock, "gi");

    const textPositions: number[] = [];
    let count = 0;

    const highlightedHtml = fullHtml.replace(blockRegex, (match, offset) => {
        count++;
        textPositions.push(offset);

        const parts = splitHtmlParts(match);

        const highlightedParts = parts
            .map((p) =>
                `<span style="background: yellow; color: black;" title="Posição ${count}">${p}</span>`
            )
            .join("");

        return highlightedParts;
    });

    return { highlightedHtml, textPositions };
};

    if (loading) {
        return <Loading size="5rem" type="spin" />;
    }

    return (
        <div className={styles.container} onMouseUp={handleMouseUp} onMouseDown={() => {setSelectedText("")}}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Button
                    className={styles.button}
                    onClick={() => window.location.href = `${PATH.base}/incluir/${fileName}`}
                >
                    <MdOutlineFileOpen size={18} />
                    Incluir
                </Button>

                <Autocomplete
                    className={styles.navigate}
                    options={listPosts.data
                        .filter((file: any) => file.file_name.replace('/', '') !== fileName?.replace('/', ''))}
                    getOptionLabel={(file) => formatFileName(file.file_name)}
                    value={listPosts.data.find((file: any) => selectedFiles.includes(file.file_name)) || null}
                    onChange={(e, newValue) => {
                        window.location.href = `${PATH.base}/revogar-ato/${newValue.file_name.replace('/', '')}`
                    }}
                    renderInput={(params) => <TextField {...params} label="Navegar" />}
                    noOptionsText="Nenhum Ato encontrado"
                    sx={{ width: 150 }}
                />
            </div>
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            {snackbarSameSelection && (
              <Snackbar
              type="sameSelection"
              setSnackbarType={setSnackbarSameSelection}
            />
            )}
            {snackbarOpen && 
                (<Snackbar
                        type="selectionError"
                        setSnackbarType={setSnackbarOpen}
                />)
            }
            {!snackbarOpen && <>
                    <Dialog fullWidth={true} maxWidth="xl" open={openDialog1} onClose={handleCloseDialog1}>
                    <DialogTitle>Texto selecionado se repete dentro do HTML</DialogTitle>
                    <DialogContent>
                        <p>O texto selecionado se repete dentro do HTML, por favor indique a posição em que o texto se encontra:</p>
                        <div
                            style={{
                                border: '1px solid #ccc',
                                marginBottom: '10px',
                                padding: '10px',
                                maxHeight: '300px',
                                overflowY: 'auto',
                                backgroundColor: '#f9f9f9',
                            }}
                            dangerouslySetInnerHTML={{ __html: highlightedHtml }}
                        />
                        <Select
                            value={selectedPosition !== null ? selectedPosition : ''}
                            onChange={(e) => setSelectedPosition(Number(e.target.value))}
                            displayEmpty
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        width: '8rem',
                                        whiteSpace: 'normal',
                                        wordWrap: 'break-word',
                                        maxHeight: '45rem',
                                    },
                                },
                            }}
                        >
                            <MenuItem value="" disabled>
                                <em className={styles.menuItemPlaceholder}>
                                    {' '}
                                    Selecione a posição{' '}
                                </em>
                            </MenuItem>
                            {textPositions.map((_, index) => (
                                <MenuItem key={index} value={index}>
                                    Posição {index + 1}
                                </MenuItem>
                            ))}
                        </Select>
                    </DialogContent>

                    <DialogActions>
                        <Button className={styles.cancelButton} onClick={handleCloseDialog1}>
                            Cancelar
                        </Button>
                        <Button
                            disabled={selectedPosition === null}
                            className={styles.button}
                            onClick={handleSelectPosition}
                        >
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog fullWidth={true} maxWidth="xl" open={openDialog2} onClose={handleCloseDialog2}>
                    <DialogTitle>Modifique o texto</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="De:"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={selectedText}
                            onChange={(e) => setSelectedText(e.target.value)}
                            multiline
                            rows={10}
                        />
                    </DialogContent>

                    <DialogContent id="para">
                        <label>Para:</label>
                        <SunEditor
                            setOptions={editorOptions}
                            lang="pt_br"
                            setContents={newText}
                            onChange={setNewText}
                        />
                    </DialogContent>
                
                    <DialogContent id="checksContainer" className={styles.checksContainer}>
                        <DialogContent id="revokeCheck" className={styles.check}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                    checked={isNoText}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setIsNoText(true);
                                            setIsExecutionSuspended(false);
                                            setIsVide(false);
                                        } else {
                                                setIsNoText(false);
                                            }
                                        }}
                                        color="primary"
                                        />
                                    }
                                    label="Sem redação/Revogado"
                                    />
                        </DialogContent>

                        <DialogContent id="suspendedExecutionCheck" className={styles.check}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                    checked={isExecutionSuspended}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setIsExecutionSuspended(true);
                                            setIsNoText(false);
                                            setIsVide(false);
                                            } else {
                                                setIsExecutionSuspended(false);
                                            }
                                        }}
                                        color="primary"
                                        />
                                    }
                                    label="Sem redação/Execução suspensa"
                                    />
                        </DialogContent>

                        <DialogContent id="videCheck" className={styles.check}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                    checked={isVide}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setIsVide(true);
                                                setIsNoText(false);
                                                setIsExecutionSuspended(false);
                                            } else {
                                                setIsVide(false);
                                            }
                                        }}
                                        color="primary"
                                        />
                                    }
                                    label="Sem redação/Vide"
                                    />
                        </DialogContent>
                    </DialogContent>

                    <DialogContent className={styles.optionsContainer}>
                        <Autocomplete
                            options={listPosts.data
                                .filter((file: any) => file.file_name.replace('/', '') !== fileName?.replace('/', ''))
                                .map((file: any) => formatFileName(file.file_name))}
                            sx={{ width: 300 }}
                            value={selectedFiles.length > 0 ? formatFileName(selectedFiles[0]) : null}
                            onChange={(e: any, newValue: string | null) => {
                                const selectedFile = listPosts.data.find(
                                    (file: any) => formatFileName(file.file_name) === newValue
                                );
                                if (selectedFile) {
                                    setSelectedFiles([selectedFile.file_name]);
                                }
                            }}
                            noOptionsText="Nenhum Ato encontrado"
                            renderInput={(params) => <TextField {...params} label="Escolha o ato responsável" />}
                            getOptionLabel={(fileName: string) => fileName}
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button id="cancelar" className={styles.cancelButton} onClick={handleCloseDialog2}>
                            Cancelar
                        </Button>
                        <Button disabled={selectedFiles.length === 0} className={styles.button} onClick={() => {
                            const div = document.createElement('div');
                            div.innerHTML = newText;
                            const plainText = div.textContent || div.innerText || '';
                            if (newText && plainText.trim() !== '') {
                                setOpenDialog3(true);
                            } else {
                                handleSubmit();
                            }
                        }}>
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openDialog3} onClose={handleCloseDialog3}>
                    <DialogTitle>Opções de Modificação</DialogTitle>
                    <DialogContent>
                        <FormControlLabel
                            checked={isRedaction}
                            control={
                                <Checkbox
                                    color="primary"
                                />
                            }
                            label="REDAÇÃO DADA"
                            onClick={handleRedaction}
                        />
                    </DialogContent>

                    <DialogContent>
                        <FormControlLabel
                            checked={isRenumbered}
                            control={
                                <Checkbox
                                    color="primary"
                                />
                            }
                            label="RENUMERADO"
                            onClick={handleRenumbered}
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button className={styles.button} onClick={handleSubmit}>
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>
                </>
            }         
        </div>
    );
};

export default RevokeEditions;